import NewFrame from './new-frame';

export default NewFrame;
